import { Grid } from "@mui/material";

import FilterItemBtn from "./FilterItemBtn";

interface Props {
	isEmpty?: boolean;
	onFilterChange: (filter: string) => void;
	filterSelected?: string;
}

const TYPES: string[] = ["ALL", "STOCK", "ETF", "FUND", "REIT", "BOND", "PP"];

export default function FilterTypes({ isEmpty, filterSelected, onFilterChange }: Props) {
	return (
		<Grid
			container
			sx={{
				position: isEmpty ? "relative" : "absolute",
				backgroundColor: "background.paper",
				pt: isEmpty ? 0 : 1
			}}
		>
			{TYPES.map((i, index) => (
				<Grid item key={index}>
					<FilterItemBtn
						type={i}
						isSelected={filterSelected === i}
						onClick={() => onFilterChange(i)}
					/>
				</Grid>
			))}
		</Grid>
	);
}
